import { appConfig as $config } from '../../app.config';
import { User } from '../User';
import { App } from '../App';
import { UI } from '../UI';
import { Common } from '../Common';

import './scss/thumbnails.scss';

const MAXFILESIZE_IN_BITES = $config.uploadFileMaxSize * 1024 * 1024;

const fTmpl = {
  box: `<div class="fileuploader-items">
        <ul class="fileuploader-items-list">
          <li class="fileuploader-thumbnails-input"><div class="fileuploader-thumbnails-input-inner"><span><i class="fal fa-image fa-lg"></i>Drag & Drop or <u>Browse</u></span></div></li>
        </ul>
      </div>`,
  item: `<li class="fileuploader-item">
        <div class="fileuploader-item-inner">
          <div class="type-holder">\$\{extension}</div>
          <div class="actions-holder">
            <button type="button" class="fileuploader-action fileuploader-action-remove" title="\$\{captions.remove}"><i class="fal fa-trash-alt"></i></button>
            <button type="button" class="fileuploader-action fileuploader-action-replace" title="Replace file"><i class="fal fa-redo"></i></button>
          </div>
          <div class="thumbnail-holder">
            \$\{image}
            <span class="fileuploader-action-popup"></span>
          </div>
          <div class="content-holder"><h5 title="\$\{name}">\$\{name}</h5></div>
          <div class="progress-holder">\$\{progressBar}</div>
        </div>
      </li>`,
  item2: `<li class="fileuploader-item">
          <div class="fileuploader-item-inner">
            <div class="type-holder">\$\{extension}</div>
            <div class="actions-holder">
              <button type="button" class="fileuploader-action fileuploader-action-remove" title="\$\{captions.remove}"><i class="fal fa-trash-alt"></i></button>
              <button type="button" class="fileuploader-action fileuploader-action-replace" title="Replace file"><i class="fal fa-redo"></i></button>
            </div>
          <div class="thumbnail-holder">
            \$\{image}
            <span class="fileuploader-action-popup"></span>
          </div>
            <div class="content-holder"><h5 title="\$\{name}">\$\{name}</h5></div>
            <div class="progress-holder">\$\{progressBar}</div>
          </div>
        </li>`
};

export const fUploader = class {
  constructor(El, options = {}) {
    this.option = {
      files: options.files || null,
      limit: options.limit || 1,
      extensions: options.extensions || null,
      blockEl: options.blockEl || false,
      listInput: options.listInput !== undefined ? options.listInput : false,
      autostart: options.autostart !== undefined ? options.autostart : false,
      disabled: options.disabled !== undefined ? options.disabled : false,
      // Additional
      imageSize: options.imageSize || false
    };
    this.El = El;
    this.pageType = options.pageType || 'Artworks';
    this.fileType = options.fileType !== undefined ? options.fileType : 0;
    this.params = options.params || null;
    this.complete = options.complete || function () {};
    this.completeOnRemove = options.completeOnRemove !== undefined ? options.completeOnRemove : false;
    this.validate = options.validate || function () {};
    this.extendParams = options.extendParams || {};
    this.isParentAccountImport = options.isParentAccountImport || false

    this.progress = false;

    this.prepare();
  }

  prepare() {
    let self = this;
    let files = self.option.files || $(self.El).data('files');
    if (files && files != '{}') {
      if (Array.isArray(files) || typeof files === 'object') {
        $(self.El).attr('data-fileuploader-files', JSON.stringify(files));
      } else {
        let file = JSON.parse(files);
        file = [{ name: file.name, size: file.size, type: 'image/png', file: file.url }];
        $(self.El).attr('data-fileuploader-files', JSON.stringify(file));
      }
    }
    $(self.El)
      .attr('fuploader', true)
      .attr('multiple', self.option.limit === null || self.option.limit > 1)
      .attr('accept', self.option.extensions ? '.' + self.option.extensions.join(', .') : '*');
    this.init();
    if (self.option.disabled) {
      self.disable();
    } else {
      self.enable();
    }
  }

  init() {
    let self = this;
    let uploader = $.fileuploader.getInstance(this.El);
    if (uploader) {
      uploader.destroy();
    }
    $(self.El).fileuploader({
      changeInput: ' ',
      listInput: self.option.listInput,
      limit: self.option.limit,
      extensions: self.option.extensions,
      // fileMaxSize: 500, //$config.uploadFileMaxSize || 20,
      theme: 'thumbnails',
      enableApi: true,
      addMore: false,
      inputNameBrackets: false,
      thumbnails: {
        box: fTmpl.box,
        item: fTmpl.item,
        item2: fTmpl.item2,
        startImageRenderer: true,
        canvasImage: false,
        removeConfirmation: false,
        itemPrepend: true,
        _selectors: {
          list: '.fileuploader-items-list',
          item: '.fileuploader-item',
          start: '.fileuploader-action-start',
          retry: '.fileuploader-action-retry',
          remove: '.fileuploader-action-remove'
        },
        onImageLoaded: function (item, listEl, parentEl, newInputEl, inputEl) {
          self.onImageLoaded(item, listEl, parentEl, newInputEl, inputEl, self);
        },
        onItemShow: function (item, listEl, parentEl, newInputEl, inputEl) {
          self.onItemShow(item, listEl, parentEl, newInputEl, inputEl, self);
        },
        onItemRemove: function (item, listEl, parentEl, newInputEl, inputEl) {
          self.onItemRemove(item, listEl, parentEl, newInputEl, inputEl, self);
        }
      },
      dragDrop: {
        container: '.fileuploader-thumbnails-input'
      },
      reader: {
        thumbnailTimeout: 5000,
        timeout: 12000,
        maxSize: 50
      },
      upload: self.upload(),
      afterRender: self.afterRender,
      beforeSelect: function (files, listEl, parentEl, newInputEl, inputEl) {
        const api = $.fileuploader.getInstance(self.El);
        const apiupload = api.getOptions().upload;
        let newUploadOpt = {
          ...apiupload,
          ...{
            url: $config.apiURL + `file/upload/`,
            chunk: false,
            tempFileName: null
          }
        };
        if (files[0].size > MAXFILESIZE_IN_BITES) {
          const tempFileName = Common._uuidv4() + '.' + files[0].name.split('.').pop();
          newUploadOpt = {
            ...apiupload,
            ...{
              url: $config.apiURL + `file/upload-chunk/`,
              chunk: $config.uploadFileChunkSize,
              tempFileName: tempFileName
            }
          };
          self.largeFileAlert();
        }
        api.setOption('upload', newUploadOpt);
        return true;
      },
      onSelect: self.onSelect,
      onEmpty: function (listEl, parentEl, newInputEl, inputEl) {
        listEl.find('.fileuploader-thumbnails-input').show();
      }
    });
  }

  onImageLoaded(item, listEl, parentEl, newInputEl, inputEl, self) {
    let api = $.fileuploader.getInstance(inputEl);

    if (self.option.imageSize && item.format == 'image') {
      if (item.reader.node) {
        if (item.reader.width < self.option.imageSize.w * 1 || item.reader.height < self.option.imageSize.h * 1) {
          //item.remove();
          //return UI.errorMessage($lang.alert.ImageSmaller);
        }
      }
    }

    item.uri = item.data?.uri || item.data?.url;
    item.fileName = item.name;

    if (self.validate) {
      self.validate(item);
    }
  }

  onItemShow(item, listEl, parentEl, newInputEl, inputEl, self) {
    let plusInput = listEl.find('.fileuploader-thumbnails-input'),
      uploadEl = listEl.find('.fileuploader-action-replace'),
      api = $.fileuploader.getInstance(inputEl.get(0));

    plusInput
      .insertBefore(item.html)
      [
        (api.getOptions().limit && api.getChoosedFiles().length >= api.getOptions().limit) ||
        api.getFiles().length >= api.getOptions().limit
          ? 'hide'
          : 'show'
      ]();

    if (self.option.limit == 1) {
      uploadEl.on('click', () => {
        api.remove(item);
        api.open();
      });
    } else {
      uploadEl.hide();
    }

    /*if(item.format == 'image'){
      item.html.find('.fileuploader-item-icon').hide();
    }*/
  }

  onItemRemove(html, listEl, parentEl, newInputEl, inputEl, self) {
    let plusInput = listEl.find('.fileuploader-thumbnails-input'),
      api = $.fileuploader.getInstance(inputEl.get(0));

    html.children().animate({ opacity: 0 }, 200, function () {
      html.remove();

      if (api.getOptions().limit && api.getChoosedFiles().length - 1 < api.getOptions().limit) plusInput.show();
    });

    if (self.validate) {
      self.validate();
    }

    if (self.completeOnRemove) {
      self.complete(self.getFiles());
    }
  }

  afterRender(listEl, parentEl, newInputEl, inputEl) {
    let plusInput = listEl.find('.fileuploader-thumbnails-input'),
      api = $.fileuploader.getInstance(inputEl.get(0));

    plusInput.on('click', function () {
      api.open();
    });

    api.getOptions().dragDrop.container = plusInput;
  }

  onSelect(item, listEl, parentEl, newInputEl, inputEl) {
    if (item.file.size > MAXFILESIZE_IN_BITES) {
      const tempFileName = Common._uuidv4() + '.' + item.name.split('.').pop();
      item.tempFileName = tempFileName;
    }
  }

  upload() {
    let self = this;

    return {
      url: $config.apiURL + `file/upload/`,

      // upload data {null, Object}
      // you can also change this Object in beforeSend callback
      // example: { option_1: '1', option_2: '2' }
      data: self.params,
      type: 'POST',
      enctype: 'multipart/form-data',

      // auto-start file upload {Boolean}
      // if false, you can use the API methods - item.upload.send() to trigger upload for each file
      // if false, you can use the upload button
      start: self.option.autostart,

      // upload the files synchron {Boolean}
      synchron: true,

      // upload large files in chunks {false, Number}
      // set file chunk size in MB as Number (ex: 4)
      chunk: false,

      beforeSend: function (item, listEl, parentEl, newInputEl, inputEl) {
        self.progress = true;

        const apiupload = $.fileuploader.getInstance(self.El).getOptions().upload;
        const accounts = User.selectedAccounts.get(self.pageType);

        item.upload.data.isTemp = 'true';
        item.upload.data.accountId = self.isParentAccountImport ? User.accountData().parentId : accounts.accountId || User.accountID();
        item.upload.data.fileType = self.pageType;
        item.upload.data.isGetImageSize = true;
        item.upload.data.type = self.fileType;
        item.upload.headers = App.ajaxHeaders();

        if (item.tempFileName) {
          item.upload.data.tempFileName = item.tempFileName;
        }
        if (apiupload.tempFileName) {
          item.upload.data.tempFileName = apiupload.tempFileName;
        }

        if (self.option.blockEl && item.upload.status != null) {
          UI.block(self.option.blockEl);
          if (item.tempFileName) {
            self.largeFileLoaderMessage();
          }
        }

        return true;
      },

      onSuccess: function (data, item, listEl, parentEl, newInputEl, inputEl, textStatus, jqXHR) {
        self.progress = false;

        if (!data.isSuccess) {
          if (data.errorInformation && data.errorInformation.errorReason) {
            UI.errorMessage(data.errorInformation.errorReason);
          }

          item.html.removeClass('upload-successful').addClass('upload-failed');
          item.html.find('.progress-holder').fadeOut(400);
          return this.onError ? this.onError(item) : null;
        }

        item.data = {
          fileName: data.fileName,
          fileUri: data.fileUri,
          uri: data.uri,
          fileType: self.fileType,
          fileStorageName: data.fileStorageName,
          additionalValues: data.additionalValues
        };

        item.html.find('.fileuploader-action-remove').addClass('fileuploader-action-success');
        setTimeout(() => {
          item.html.find('.progress-holder').fadeOut(400);
        }, 400);
      },

      onError: function (item, listEl, parentEl, newInputEl, inputEl, jqXHR, textStatus, errorThrown) {
        self.progress = false;

        let progressBar = item.html.find('.progress-holder');
        if (progressBar.length > 0) {
          progressBar.find('span').html(0 + '%');
          progressBar.find('.fileuploader-progressbar .bar').width(0 + '%');
          item.html.find('.progress-holder').fadeOut(400);
        }

        item.upload.status != 'cancelled' && item.html.find('.fileuploader-action-retry').length == 0
          ? item.html
              .find('.column-actions')
              .prepend('<a class="fileuploader-action fileuploader-action-retry" title="Retry"><i></i></a>')
          : null;
      },

      onProgress: function (data, item, listEl, parentEl, newInputEl, inputEl) {
        let $progressBar = item.html.find('.progress-holder');
        if ($progressBar.length) {
          $progressBar.show();
          $progressBar.find('span').text(data.percentage >= 99 ? 'Uploading...' : data.percentage + '%');
          $progressBar.find('.fileuploader-progressbar .bar').width(data.percentage + '%');
        }
      },

      // Callback fired after all files were uploaded
      onComplete: function (listEl, parentEl, newInputEl, inputEl, jqXHR, textStatus) {
        if (jqXHR.responseJSON && jqXHR.responseJSON.isSuccess) {
          if (!$(self.option.blockEl).length) {
            return;
          }

          self.progress = false;

          if (self.option.blockEl) {
            UI.unblock(self.option.blockEl);
          }

          self.complete(self.getFiles());
        }
      }
    };
  }

  /*
   **  - Public
   */
  setOptions(opt = {}) {
    let api = $.fileuploader.getInstance(this.El);
    let files = api.getFiles();
    files.forEach((item) => {
      api.remove(item);
    });
    if (opt.limit) api.setOption('limit', opt.limit);
    if (opt.extensions) api.setOption('extensions', opt.limit);
    api.reset();
  }

  destroy() {
    let api = $.fileuploader.getInstance(this.El);
    api.destroy();
  }

  reset() {
    let api = $.fileuploader.getInstance(this.El);
    api.reset(true);
  }

  getFiles() {
    let api = $.fileuploader.getInstance(this.El);
    return this.m_completeFiles(api.getFileList());
  }

  getChoosedFiles() {
    let api = $.fileuploader.getInstance(this.El);
    return this.m_completeFiles(api.getChoosedFiles());
  }

  uploadStart() {
    let api = $.fileuploader.getInstance(this.El);
    return api.uploadStart();
  }

  inProgress() {
    return this.progress;
  }

  disable() {
    let api = $.fileuploader.getInstance(this.El);
    api.disable(true);
  }

  enable() {
    let api = $.fileuploader.getInstance(this.El);
    api.enable();
  }

  /*
   **  - Mapping
   */
  m_completeFiles(data) {
    let files = [];
    data.forEach((item) => {
      let obj = {
        ...this.extendParams,
        ...{
          index: Common._uuidv4(),
          fileType: item.data.fileType,
          size: item.size,
          size2: item.size2,
          title: item.title,
          type: item.data.type,
          extension: item.extension,
          fileName: item.data.fileName,
          fileStorageName: item.data.fileStorageName,
          fileUri: item.data.fileUri,
          uri: item.data.uri,
          data: item.data,
          file: item.file,
          reader: item.reader,
          additionalValues: item.data.additionalValues
            ? item.data.additionalValues
            : item.format == 'image' && item.reader
            ? { width: item.reader.width, height: item.reader.height }
            : {},
          IsAdd: true
        }
      };
      files.push(obj);
    });
    return files;
  }

  largeFileAlert() {
    bootbox.dialog({
      title: $lang.assetsManager.Largefile,
      message: $lang.assetsManager.LargefileDialogMessage,
      buttons: {
        ok: {
          label: $lang.btn.gotIt,
          className: 'btn btn-brand'
        }
      }
    });
  }

  largeFileLoaderMessage() {
    const self = this;
    const mess = $('<span>' + $lang.assetsManager.LargefileLoaderMessage + '</span>');
    $('.blockUI.blockMsg', $(self.option.blockEl)).append(
      mess.addClass('text-danger').css({ position: 'relative', top: '20px', left: '-50%' })
    );
  }
};
